import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { adminPrefix } from 'configs/routePrefix';
import DealService from "services/Admin/DealService"
import StatusModal from "../StatusModal"
import FeedbackModal from "../FeedbackModal"
import { useSelector } from "react-redux"
import UploadReceiptModal from 'components/Website/Cards/UploadReceiptModal';
import ReceiptService from 'services/Admin/ReceiptService';
import MessageModal from '../MessageModal';
import AssignSalesRepModal from '../AssignSalesRep';

const CardItem = ({ history, item, setShouldGetData, setIdsSelected, idsSelected, setSelectAll }) => {
    const dealService = new DealService()
    const receiptService = new ReceiptService()
    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [salesRepModal, setSalesRepModal] = useState(false)
    const [sendMessage, setSendMessage] = useState(false)
    const [rModal, setRModal] =useState(false)
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const [formState, setFormState] = useState({media: item?.reciept})
    const [status, setStatus] = useState(item?.status)

    const handleCloseModal = (action) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };
    const addActivityHandler = () => {
        if (item ?.sales_rep ?.id) {
            history.push(`${adminPrefix}/deals/deal-activity/${item.id}/${item.lead_id}/${item ?.sales_rep ?.id}`)
        } else {
            toast.error("Please assign Sales Rep ")
        }
    }

    return (
        <>
            <tr>
                <td className="font-size-14">
                    <label className="m-0 d-flex" style={{gap: '8px'}}>
                        <input 
                            type='checkbox' 
                            onChange={e => {
                                if(e.target.checked){
                                    setIdsSelected([...idsSelected, item.id])
                                } else {
                                    setIdsSelected([...idsSelected.filter(res=> res != item.id)])
                                    setSelectAll(false)
                                }
                            }} 
                            checked={!!idsSelected.filter(res=> res == item?.id)?.length}
                        />
                        {item.id}
                    </label>
                </td>
                <td className="font-size-14" style={{textWrap: 'nowrap'}}>{item.client.user_name}</td>
                <td className="font-size-14">{item.sales_rep.name}</td>
                <td className="font-size-14">{item.created_at}</td>
                <td className="font-size-14">
                    {item?.unit?.unit_type ?.name ?.en ? item?.unit?.unit_type ?.name ?.en : item?.resale?.resale_type?.name?.en}
                </td>
                <td className="font-size-14">{item?.compound?.name?.en ? item?.compound?.name?.en : '-'}</td>
                <td className="font-size-14">
                    {item.price ? toCurrency(item.price) : toCurrency(item?.resale?.payment_plan?.total_price)}
                </td>
                <td className="font-size-14 text-left">
                    {!!item?.developer_status ? <Badge 
                        className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item?.developer_status[0]?.status) }}>
                            {item?.developer_status[0]?.status}
                    </Badge> : '-'}
                </td>
                <td className="font-size-14 text-left">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(status) }}>{status}</Badge>
                </td>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => history.push(`${adminPrefix}/deals/view-deal/${item.id}`)}>View</DropdownItem>
                            {isExist("deal.edit") ? <DropdownItem onClick={() => history.push(`${adminPrefix}/deals/Edit-deal/${item.id}`)}>Edit</DropdownItem> : null}
                            <DropdownItem onClick={() => setSendMessage(true)}>Send Message</DropdownItem>
                            
                            {isExist("deal.activity") ? <DropdownItem onClick={addActivityHandler}>Add Activity</DropdownItem> : null}
                            {!item?.reciept && item.status ==='Open' && <DropdownItem onClick={() => setRModal(true)}>Add Receipt for Client</DropdownItem>}
                            {isExist("deal.feedback") ? <DropdownItem onClick={() => {
                                if (item ?.sales_rep ?.id) {
                                    setFeedbackModal(true)
                                } else {
                                    toast.error("Please assign Sales Rep ")
                                }
                            }}>Add Feedback</DropdownItem> : null}
                              {/* {isExist("deal.appointment") ? */}
                               <DropdownItem onClick={() => {
                                     history.push(`${adminPrefix}/appoinments/book-appoinment/add/${item.lead_id}/${item ?.sales_rep ?.id}`)
                            }}>Book Appointment</DropdownItem>
                             {/* : null} */}
                            <DropdownItem onClick={() => {
                                setSalesRepModal(c => !c)
                            }}>{!!item?.sales_rep?.id ? "Re-assign Sales Rep" : "Assign Sales Rep"}</DropdownItem>
                            {isExist("deal.delete") ? <DropdownItem className="text-danger" onClick={() => { setDeleteModal(true) }}>Remove Deal</DropdownItem> : null}
                            {isExist("deal.edit") ?
                                <>
                                    <hr className="m-0 p-0" />
                                    <DropdownItem onClick={() => setModalStatus(true)} style={{ color: "#212529" }} >Change Status</DropdownItem>
                                </>
                                : null}
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            {rModal && <UploadReceiptModal 
                rModal={rModal} 
                setRModal={setRModal} 
                form={formState.media} 
                setStatus={setStatus}
                dealId={item.id} 
                setShouldGetData={setShouldGetData}
                Service={receiptService} />}
            {deleteModal && <DeleteModal
                open={deleteModal}
                titleMsg={"Appoinment"}
                deletedItem={item}
                modelService={dealService}
                onCloseModal={(action) => handleCloseModal(action)}
            />}
            {modalStatus &&<StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                multi={false}
                setShouldGetData={setShouldGetData}
            />}
            { feedbackModal && <FeedbackModal
                    modal={feedbackModal}
                    id={item.id}
                    toggle={() => setFeedbackModal(!feedbackModal)}
                    type="list"
                    setShouldUpdateDate={() => { }}
                /> }
            {salesRepModal && <AssignSalesRepModal
                modal={salesRepModal}
                toggle={() => setSalesRepModal(c => !c)}
                idsSelected={[item.id]}
                setShouldGetData={setShouldGetData}
            />}
            {sendMessage && <MessageModal 
                modal={sendMessage}
                id={item.id}
                setModal={setSendMessage}
                Service={dealService}
            />}
        </>

    );
}
const getBackGround = (status) => {
    return status === "Contacted" ? "#db1fdb"
    : status === "Uncontacted" ? "#74788d"
        : status === "Lost" ? "#bf060b"
            : status === "Won" ? "#34e38f"
                : status === "Open" ? "#50a5f1" :
                status === "Unreachable" ? "#556ee6" :
                status === "Removed" ? "#ff0000" : "#f1874c"

}
const toCurrency = (number) => {
    const numberInt = parseInt(number)
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(numberInt);
}

export default CardItem;